/**
 * CostCenterChart Component
 * 
 * Gráfico de barras horizontais para centros de custo.
 */

import React from 'react'
import './CostCenterChart.css'

function CostCenterChart({ data = [], onItemClick }) {
  if (!data || data.length === 0) {
    return (
      <div className="cost-center-chart-empty">
        <p>Nenhum dado disponível</p>
      </div>
    )
  }

  const formatCurrency = (val) => 
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val)

  return (
    <div className="cost-center-chart">
      {data.map((item, i) => (
        <div
          key={item.id || i}
          className="cost-center-chart-item"
          onClick={() => onItemClick && onItemClick(item)}
        >
          <div className="cost-center-chart-item-header">
            <span className="cost-center-chart-item-label">{item.name}</span>
            <span className="cost-center-chart-item-amount">{formatCurrency(item.amount || 0)}</span>
          </div>
          <div className="cost-center-chart-item-bar-container">
            <div
              className="cost-center-chart-item-bar"
              style={{ 
                width: `${item.percentage || 0}%`,
                backgroundColor: item.color || '#16a34a'
              }}
            />
          </div>
          <div className="cost-center-chart-item-footer">
            <span className="cost-center-chart-item-percentage">{item.percentage?.toFixed(1) || 0}%</span>
          </div>
        </div>
      ))}
    </div>
  )
}

export default CostCenterChart
